import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useUserStore} from '@/stores/user'
import router from '@/router'

const baseURL = '/api'
const instance = axios.create({ baseURL:baseURL})

//axios请求拦截器
instance.interceptors.request.use(config => {
    //获取token
    const userStore = useUserStore()
    //拼接token
    const token = userStore.token
    if(token){
        config.headers.token = token
    }
    return config
}, e => Promise.reject(e))

//axios响应式拦截器
instance.interceptors.response.use(
    res => {
        // 兼容不同后端返回的成功码（1 / 200）
        if (res.data.code===1 || res.data.code===200) {
            return res.data;
        }
        if(res.data.msg === 'NOT_LOGIN'){
            router.replace('/login');
        }
        if(res.data.msg === 'DATE_EXPIRE'){
            const userStore = useUserStore()
            userStore.clearToken();
            router.replace('/login');
        }
        ElMessage({
            type:'warning',
            message:res.data.msg
        })
        return Promise.reject(res.data)
    }, e => {
    return Promise.reject(e)
})

export default instance